import { Component, Input, OnInit } from '@angular/core';
import { SettlementsService } from 'src/app/services/settlements.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-item-tiny-user',
  template: `
    <div style="overflow: hidden; width: 44px; height: 44px; border-radius: 40px;">
    <img [src]="avatarURL" width="100%">
    </div>
  `,
  styleUrls: []
})
export class ItemTinyUserComponent implements OnInit {
  @Input() user: any;

  avatarURL: string = '';
  apiUrl: string = environment.AWS_REST_WSPREFIX;

  constructor(
    private store: SettlementsService,
  ) { }

  ngOnInit(): void {
    // this.loadAvatar();
  }

  loadAvatar() {
    this.store.getUser(this.user.id).subscribe({
      next: (user: any) => {
        
        let el = user.avatar;
        console.log('el => ', el);
        if (el == null) {
          this.avatarURL = 'assets/images/avatar.png';
        } else {
          this.avatarURL = `${this.apiUrl}/storage/${el.blob.key.substring(0,2)}/${el.blob.key.substring(2,4)}/${el.blob.key}`;
        }
      },
      error: (err: any) => {
        this.avatarURL = 'assets/images/avatar.png';
      }
    });
  }
}
